import { render, staticRenderFns } from "./OJHeader.vue?vue&type=template&id=61957ef4&scoped=true"
import script from "./OJHeader.vue?vue&type=script&lang=js"
export * from "./OJHeader.vue?vue&type=script&lang=js"
import style0 from "./OJHeader.vue?vue&type=style&index=0&id=61957ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61957ef4",
  null
  
)

export default component.exports